import { FC, useState } from "react";

import { isTelegramMobileWebview } from "@repo/edtech-shared";
import { ScopedModal } from "@repo/wb-ui-kit";

import st from './TelegramWarningModal.module.scss';

const hasTelegramWebviewWarnBeenShown = (): boolean => {
  return sessionStorage.getItem('telegram-webview-warn-shown') === "true";
};

const shouldShowModal = (): boolean => {
  return (
    isTelegramMobileWebview() &&
    !hasTelegramWebviewWarnBeenShown()
  );
};

export const TelegramWarningModal: FC = () => {
  const [ isOpen, setIsOpen ] = useState<boolean>(() => shouldShowModal());

  const onModalClose = () => {
    sessionStorage.setItem('telegram-webview-warn-shown', "true");
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <ScopedModal
      fullscreen
      showCloseButton
      isOpen={isOpen}
      onClose={onModalClose}
    >
      <div className={st.content}>
        <h2 className={st.title}>Перейдите в браузер</h2>
        <p className={st.desc}>
          Нажмите на три точки в правом верхнем углу и выберите «Открыть в…» — это нужно для корректной работы портала обучения
        </p>
      </div>
    </ScopedModal>
  );
};
